import { Wording } from '@/types';

export const ASTROLOGY_WORDING_EN: Wording = {
  components_header_media_content: 'Audios',
  components_header_media_1: 'Meditations',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Guides',
  components_header_text2: 'Blog',
  components_header_members: 'Members',
  hero_text: 'Explore the Stars Within',
  hero_button_text: 'Start Here',
  components_ressources_section_title: 'RESOURCES',
  components_ressources_subheader_text:
    'All the Tools You Need for Cosmic Insight and Self-Discovery',
  components_ressources_span_text:
    "Expand your inner universe with a curated blend of podcasts and articles. Whether you're seeking cosmic insight, clarity, or spiritual alignment, our resources help you connect with astrology in practical, meaningful ways.",
  components_ressources_card_1_title: 'Deep Dives',
  components_ressources_card_1_text:
    'Dive into a rich collection of in-depth podcasts covering astrology, tarot, cosmic archetypes, and spiritual growth—designed to expand your awareness and deepen your practice.',
  components_ressources_card_2_title: 'Star Insights',
  components_ressources_card_2_text:
    'Astrological tips and blogposts for self-awareness and soulful growth.',
  components_ressources_link: 'Explore Further',
  components_notes_and_google_title_1: 'Astrological Guidance',
  components_notes_and_google_title_2: 'Cosmic Routine',
  components_notes_and_google_title_3: 'Reflections',
  components_review_google_text: 'Reviews',
  media_content_section_title: 'AUDIOS',
  media_content_section_subheader_text: 'Our podcast',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'More episodes',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Articles & Insights',
  text2_section_button_more: 'Load More',
  components_text1_section_title: 'GUIDES',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: 'View All Guides',
  components_footer_text: 'Awaken Your Inner Cosmos: Your Path, Your Stars.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registration number',
  components_footer_legal: 'Legal',
  components_footer_terms: 'Terms and Conditions',
  components_footer_privacy: 'Privacy Policy',
  button_load_more: 'Load More',
  page_media_1_content_hero_text: 'Podcast Episodes',
  page_media_content_menu_foundations: 'Foundations',
  page_media_content_menu_spirituality: 'Spirituality',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psychology',
  page_media_content_menu_trends: 'Trends',
  page_media_2_content_hero_text: 'Media 2',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Our Blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Articles & Insights',
  enter_email_title: 'Please enter your email to continue',
  enter_email_placeholder_email: 'Email',
  enter_email_button_enter: 'Enter',
  components_login_success_text: 'Login successful!',
  components_card_link_media_content: 'Listen Now',
  components_card_link_text1_content: 'View Guide',
  components_card_link_text2_content: 'View Article',
  france: 'France',
  cyprus: 'Cyprus',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditation',
  page_media_content_menu_all: 'All',
};
